import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Pricelist from "./pages/Pricelist";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/pricelist" element={<Pricelist />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
